<template>
  <div class="my-home">
    <TopLogo size='1400'/>
    <div class="wrap1400 top20 fix">
      <div class="my-left">
        <h3>模块功能</h3>
        <div class="left-auto" ref='homeLeft'>
          <div class="nav-one nav-bottom">
            <h4><i class="icons icon-order"></i>礼品订单</h4>
            <span><router-link to="/my/order">订单列表</router-link></span>
          </div>
          <div class="nav-one">
            <h4><i class="icons icon-jifen"></i>积分管理</h4>
            <span><router-link to="/my/jifen">店铺积分</router-link></span>
          </div>
        </div>
        
      </div>

      <div ref='homeRight' class="my-right">
        <Nav />
        <keep-alive :max="10">
          <router-view v-if="isRouterAlive"/>
        </keep-alive>
      </div>
    </div>
  </div>
</template>

<script>
import TopLogo from "../components/top-logo.vue";
import Nav from "../components/nav.vue";

export default {
  components: {
    TopLogo,
    Nav
  },
  data() {
    return {
      isRouterAlive: true,
      clientHeight: ""
    };
  },
  created() {
    // this.$router.push("/my/welcome");
    // this.$store.dispatch("NAVCON",[]);
  },
  watch: {
    clientHeight: function() {
      this.changeFixed(this.clientHeight);
    }
  },
  mounted() {
    this.$store.commit("SET_HEIGHT", document.documentElement.clientHeight - 200)
    const that = this;
    window.onresize = function temp() {
      that.clientHeight = `${document.documentElement.clientHeight}`;
    };
  },
  methods: {
    changeFixed(clientHeight) {
      this.$store.commit("SET_HEIGHT", clientHeight - 200)
      this.$refs.homeLeft.style.maxHeight = clientHeight - 150 + "px";
    },
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(() => (this.isRouterAlive = true));
    }
  }
};
</script>
<style>
.my-left {
  float: left;
  width: 200px;
  border: 1px solid #eee;
  border-radius: 4px;
}
.left-auto {
  overflow-y: auto;
}
.my-right {
  width: 1180px;
  float: right;
  border: 1px solid #eee;
  border-radius: 4px;
  margin: 37px 0 0 0;
}
.my-left h3 {
  line-height: 50px;
  border-bottom: 1px solid #eee;
  text-align: left;
  padding-left: 20px;
  font-size: 16px;
  font-weight: inherit;
}
.my-left h4 {
  text-align: left;
  margin-left: 10px;
  font-size: 14px;
  font-weight: inherit;
  line-height: 30px;
}
.my-left span {
  width: 50%;
  display: block;
  text-align: left;
  padding-left: 10px;
  line-height: 36px;
}
.my-left .nav-one {
  margin: 10px;
}
.nav-bottom {
  border-bottom: 1px solid #eee;
}
.icon-order {
  background-position: 0 -32px;
  display: inline-block;
  width: 17px;
  height: 20px;
  cursor: pointer;
  vertical-align: -5px;
  margin-right: 4px;
}
.icon-jifen {
  background-position: -18px -32px;
  display: inline-block;
  width: 20px;
  height: 20px;
  cursor: pointer;
  vertical-align: -5px;
  margin-right: 4px;
}

.router-link-exact-active {
  color: #169bd5;
}
</style>